import { R2_PUBLIC_URL } from '@core/config/constants';

/**
 * Utility function to check and format image URLs
 * If the URL is relative (just a filename), it prepends the R2 public URL
 */
export const checkingImageUrl = (
  url: string | undefined | null,
  baseUrlOverride?: string | null
): string => {
  if (!url) return '';
  
  // If it's already a full URL, return it
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('data:')
  ) {
    return url;
  }
  
  // Clean the URL: remove leading slash and any JSON artifacts (brackets, quotes, backslashes)
  let cleanUrl = url.trim();
  if (cleanUrl.startsWith('/')) {
    cleanUrl = cleanUrl.slice(1);
  }
  
  // Strip common JSON formatting characters if they exist (keep spaces for filenames)
  cleanUrl = cleanUrl.replace(/[[\]"\\]/g, '');
  
  const baseRaw =
    baseUrlOverride != null && String(baseUrlOverride).trim() !== ''
      ? String(baseUrlOverride).trim()
      : R2_PUBLIC_URL;
  const baseUrl = baseRaw.endsWith('/') ? baseRaw : `${baseRaw}/`;
  
  // Encode the filename to handle spaces correctly in the URL
  return `${baseUrl}${cleanUrl.split('/').map(segment => encodeURIComponent(segment)).join('/')}`;
};
